<div #scrollContainer class="adhoc-test-view">
  @if (!activeTestRun) {
    <div class="active-indicator-inactive">
      @if (!!manualTestStartError) {
        <div class="inactive-actions error-state">
          <div class="inactive-message">{{manualTestStartError}}</div>
        </div>
      } @else {
        <div class="inactive-actions pending-state">
          <fa-icon [icon]="pendingIcon" animation="spin"></fa-icon>
          <div class="inactive-message">{{manualTestPendingMessage}}</div>
        </div>
      }
    </div>
  } @else {
    <div class="active-indicator">
      <div class="test-run-name">
        @if (!modifyingName) {
          <span (click)="modifiedName = modifiedName || activeTestRun.name || ''; modifyingName = true; $event.stopPropagation();" class="label">{{activeTestRun.name || "Unknown"}}</span>
        }
        @if (modifyingName) {
          <div class="modifying-name">
            <input #nameInput (keydown.enter)="saveTestNameModification();" (blur)="(!modifiedName || modifiedName === activeTestRun.name) && (modifyingName = false);" size="24" type="text" pInputText [(ngModel)]="modifiedName">
          </div>
        }
        @if (modifiedName && modifiedName != activeTestRun.name) {
          <div class="confirmation-area">
            @if (!testNameModificationInProgress) {
              <button pButton class="p-button-rounded p-button-text" pTooltip="Save changes" tooltipPosition="top" icon="true" (click)="saveTestNameModification(); $event.stopPropagation();">
                <fa-icon icon="save"></fa-icon>
              </button>
            }
            @if (testNameModificationInProgress) {
              <button pButton class="p-button-rounded p-button-text" icon="true">
                <fa-icon icon="cog" animation="spin"></fa-icon>
              </button>
            }
            <button pButton class="p-button-rounded p-button-text" (click)="clearModifyName(); $event.stopPropagation();" pTooltip="Cancel" tooltipPosition="top" icon="true">
              <fa-icon icon="times"></fa-icon>
            </button>
          </div>
        }
      </div>
      <div class="top-row">
        <button pButton data-testing-id="finish-test-run-btn" type="button" (click)="finishTestRun()" [disabled]="finishingTestRun" label="Finish Test"></button>
        <div class="open-test-run-container" (click)="openTestRunInWebmate(activeTestRun.testRunId)" data-testing-id="open-active-test-run-btn">
          Open
          <fa-icon [icon]="externalLink" class="testrunlink"></fa-icon>
        </div>
      </div>
      <div class="active-run-container">
        Test State
        <wm-test-status-switcher [testRun]="activeTestRun" [large]="true" [showPending]="true"></wm-test-status-switcher>
      </div>
    </div>

    <div class="findings-section-heading">Findings</div>
    @for (finding of findings; track finding.id) {
      <div #findingEntry class="finding-entry-container">
        <div class="finding-click-overlay" [ngClass]="{'hidden': !findingElement.findingCollapsed}" (click)="findingElement.toggleFinding(); $event.stopPropagation()"></div>
        <wm-finding-finding #findingElement [finding]="finding" [condensedMeta]="true" [collapsable]="true"></wm-finding-finding>
      </div>
    }
    @if(findings?.length === 0) {
      <div class="findings-empty">
        No Findings found
      </div>
    }

    <div>
      <wm-add-finding-button
          [projectId]="projectId"
          findingType="Manual.AdHocResult"
          [testRun]="activeTestRunId"
          [existingFindingsCount]="findings?.length ?? 0"
          (findingCreated)="onFindingCreated($event)"
          data-testing-id="test-run-add-findings-btn">
      </wm-add-finding-button>
    </div>

  }
</div>
